import { StoreView } from 'resources/constants'
import { sofiaTheme } from 'app/sofia/resources/theme'
import { livBriteTheme } from 'app/livbrite/resources/theme'

const isSofiaAndGrace = process.env.REACT_APP_MAGENTO_STORE_VIEW === StoreView.SofiaAndGrace
const isLivBrite = process.env.REACT_APP_MAGENTO_STORE_VIEW === StoreView.LivBrite

export const useStoreView = () => {
  return {
    isSofiaAndGrace,
    isLivBrite,
    theme: isSofiaAndGrace ? sofiaTheme : livBriteTheme
  }
}
